import { Component, inject } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { NavHistoryService } from './services/nav-history.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AppHeaderComponent } from './app-header/app-header.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { CommonModule } from '@angular/common';
import { RightBridgeApiService } from './services/right-bridge-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [AppHeaderComponent, AppFooterComponent, RouterOutlet, CommonModule],
})
export class AppComponent {
  router = inject(Router);
  private navigation = inject(NavHistoryService);
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private gtmService = inject(GoogleTagManagerService);
  private rbs = inject(RightBridgeApiService);

  loggedIn = this.rbs.loggedIn;
  title = 'app';
  apps = ['pp', 'aw', 'iw', 'lw', 'cm'];

  constructor() {
    this.navigation.startSaveHistory();
    this.apps.map(app => {
      this.matIconRegistry.addSvgIcon(
        `${app}_icon`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `..${
            window.location.host.includes('localhost') ? '' : '/app'
          }/assets/${app}-icon.svg`
        )
      );
    });

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }
}
